import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CoreForm } from "../components/CoreForm";
import { CoreInput } from "../components/CoreInput";
import { Coreselect } from "../components/CoreSelect";
import { CoreTab } from "../components/CoreTab";
import { CoreTabs } from "../components/CoreTabs";
import { Expressions, MaxLength, RegexValidation, RequiredValidation } from "../components/CoreValidations";
import AuthService from "../services/authService";
import FormService, { FormStatusList } from "../services/formService";
import ProjetoService from "../services/projetoService";
import listaBancos from "../listabancos.json";

import { CoreButton } from "../components/CoreButton";
import { downloadBlob } from "../services/download.service";
import { ModalSystem } from "../systems";
import { TextareaDialog } from "./dialogs/TextareaDialog";
import { AlertIcon } from "../assets/icons/icon-alert";
import { FormStatus } from "../components/FormStatus";
import { CorePdfViwer } from "../components/CorePdfViewr";
import { Loader } from "./Loader";


// External Data
const docenteDiscenteList = [
    { id: "Docente", name: "Docente" },
    { id: "Discente", name: "Discente" },
]

const estadosCivis = [
    { value: "solteiro(a)", name: "solteiro(a)" },
    { value: "casado(a)", name: "casado(a)" },
    { value: "separado(a)", name: "separado(a)" },
    { value: "divorciado(a)", name: "divorciado(a)" },
    { value: "viúvo(a)", name: "viúvo(a)" },
    { value: "", name: "não informado" },

]


export const FormEditView = () => {

    let params = useParams();
    let history = useNavigate();


    let [inEditMode, setInEditMode] = useState(true);
    let [hasFormError, setHasFormError] = useState(true);
    let [formErrors, setFormErrors] = useState<CoreFormErrors>({});
    let [status, setStatus] = useState<string>("");
    let [tabErrors, setTabErrors] = useState({
        dadodsPessoais: false,
        contato: false,
        dadosBancarios: false,
        projeto: false,
        contrato: false,
        termo: false
    })
    let [serverValidating, setServerValidating] = useState(false);


    let [data, setData] = useState({
        formId: "",
        docenteDiscente: "Discente",
        matricula: "0000",
        siape: "",
        cpf: "",
        pis: "",
        email: "",
        nomeCompleto: "",
        nomeSocial: "",
        identidade: "",
        estadoCivil: "",
        dataNascimento: "",
        nacionalidade: "",
        pai: "",
        mae: "",
        endereco: "",
        complemento: "",
        bairro: "",
        cidade: "Manaus",
        estado: "Amazonas",
        cep: "",
        fone: "",
        fone2: "",
        banco: "",
        tipoConta: "Corrente",
        agencia: "",
        conta: "",
        tipoChavePix: "CPF",
        chavePix: "",
        projetoId: "",
        funcao: "",
        inicioContrato: "",
        fimContrato: "",
        cargaHoraria: 100,
        quantidadeParcelas: 1,
        valorParcela: 0,
        valorBruto: 0,
        termo: "",
        processo: "",
        status: 0,
        statusUpdateDescription: ""

    });

    let projetos: Projeto[] = [];
    let [auxillaryData, setAuxiliary] = useState({
        isPublicServer: "false",

        projetos,
        coordenadorChefeNome: "",
        coordenadorProjetoNome: "",
        coordenadorUnidadeNome: "",

        instituicaoExecutora: "",
        modalidade: "",
        inicioProjeto: "",
        fimProjeto: "",
        docFile: undefined,
        serverValidations: []
    });
    let [isInProgress, setInProgress] = useState(false);



    const populateAuxiliaryData = async (projectId?: string) => {

        const { data: projetos } = await ProjetoService.getProjetos();



        auxillaryData.projetos = projetos;



        let projId = projectId || projetos[0].projetoId;


        if (projId) {
            let projetoSelected = projetos.find(p => p.projetoId == projId);


            auxillaryData.coordenadorChefeNome = projetoSelected.coordenadorChefeNome;
            auxillaryData.coordenadorProjetoNome = projetoSelected.coordenadorProjetoNome;
            auxillaryData.coordenadorUnidadeNome = projetoSelected.coordenadorUnidadeNome;

            auxillaryData.instituicaoExecutora = projetoSelected.instituicaoExecutora;
            auxillaryData.modalidade = projetoSelected.modalidade;
            auxillaryData.inicioProjeto = projetoSelected.inicioProjeto || "";
            auxillaryData.fimProjeto = projetoSelected.fimProjeto || "";
        }



        setAuxiliary({
            ...auxillaryData,
        });

        //if is New,  setProject ID
        if (!inEditMode) {
            setData({
                ...data,
                projetoId: projId
            });

        }

    }

    // server Validation useEffect
    useEffect(() => {
        if (data.inicioContrato && data.fimContrato)
            fetchValidations();
    }, [data.inicioContrato, data.fimContrato])

    const fetchValidations = async () => {
        setServerValidating(true);
        let serverValidations = await FormService.getFormValidations(data as Form);
        auxillaryData.serverValidations = serverValidations;
        setAuxiliary({
            ...auxillaryData,
            serverValidations
        })
        setServerValidating(false);

    }

    const populateEdit = async (formId: string) => {
        setInProgress(true);
        setStatus("Carregando Formulário...");
        let form = await FormService.getForm(formId);

        // cant be null
        form.data.inicioContrato = form.data.inicioContrato || "";
        form.data.fimContrato = form.data.fimContrato || "";
        form.data.funcao = form.data.funcao || "";
        form.data.quantidadeParcelas = form.data.quantidadeParcelas || 1;
        form.data.termo = form.data.termo || "";
        form.data.processo = form.data.processo || "";
        form.data.pis = form.data.pis || "";
        form.data.estadoCivil = form.data.estadoCivil || "";




        setData(form.data as any);
        await populateAuxiliaryData(form.data.projetoId);

        setStatus("");
        setInProgress(false);

    }

    const populateNew = async () => {
        setInProgress(true);
        let user = AuthService.getCurrentUser();
        data.nomeCompleto = user.FullName || "";
        data.email = user.sub || "";
        data.cpf = user.cpf || "";
        data.estadoCivil = data.estadoCivil || "";

        setData(data);
        await populateAuxiliaryData();
        setInProgress(false);
    }


    const init = () => {
        let id = params.id;
        let isEdit = id != "novo";
        setStatus("Carregando formulário...");

        inEditMode = isEdit;
        setInEditMode(isEdit);


        if (isEdit)
            populateEdit(id);
        else {
            populateNew();
        }
    }

    useEffect(() => {
        init();

    }, [])


    const onValueChange = ({ name, value }: CoreEventChange) => {



        if (name == "docenteDiscente") {
            data.matricula = "";
            data.siape = "";
        }

        if (name == "tipoChavePix")
            data.chavePix = ""

        if (name == "projetoId" && auxillaryData.projetos.length > 0) {

            let projetoSelected = auxillaryData.projetos.find(i => i.projetoId == value);
            auxillaryData.coordenadorChefeNome = projetoSelected.coordenadorChefeNome;
            auxillaryData.coordenadorProjetoNome = projetoSelected.coordenadorProjetoNome;
            auxillaryData.coordenadorUnidadeNome = projetoSelected.coordenadorUnidadeNome;

            auxillaryData.instituicaoExecutora = projetoSelected.instituicaoExecutora;
            auxillaryData.modalidade = projetoSelected.modalidade;
            auxillaryData.inicioProjeto = projetoSelected.inicioProjeto;
            auxillaryData.fimProjeto = projetoSelected.fimProjeto;

            setAuxiliary({ ...auxillaryData });
            fetchValidations();
        }

        if (name === "quantidadeParcelas" && !isNaN(value as number)) {
            value = parseInt(value as string);
            data.quantidadeParcelas = value;
            data.valorBruto = (value as number) * data.valorParcela;
        }

        if (name === "valorParcela" && !isNaN(value as number)) {
            data.valorBruto = data.quantidadeParcelas * (value as number);
        }

        if (name == "cargaHoraria") {
            value = parseInt(value.toString());
            data.cargaHoraria = parseInt(value.toString());
        }



        setData({
            ...data,
            [name]: value
        });

    }

    const onAuxiliaryChange = ({ name, value, files }: CoreEventChange) => {




        setAuxiliary({
            ...auxillaryData,
            [name]: value,
            docFile: files ? files[0] : undefined
        });

    }

    const onFormError = (errors: CoreFormErrors) => {

        let hasError = Object.keys(errors).length > 0;
        Object.keys(errors).map(k => {

        });

        tabErrors.dadodsPessoais = hasFormErrorOnGroup(errors, "Dados Pessoais");
        tabErrors.contato = hasFormErrorOnGroup(errors, "Contato");
        tabErrors.dadosBancarios = hasFormErrorOnGroup(errors, "Dados Bancários");
        tabErrors.projeto = hasFormErrorOnGroup(errors, "Projeto");
        tabErrors.contrato = hasFormErrorOnGroup(errors, "Contrato");
        tabErrors.termo = hasFormErrorOnGroup(errors, "Termo");

        setTabErrors({ ...tabErrors });
        setHasFormError(hasError);
        setFormErrors(errors);
    }

    // TODO: send to form API
    const hasFormErrorOnGroup = (errors: CoreFormErrors, group: string) => {
        return Object.keys(errors).filter(k => errors[k].group == group).length > 0;
    }

    const OnSave = async () => {

        setInProgress(true);
        setStatus("Salvando formulário...");

        const body = { ...data };

        if (body.inicioContrato == "")
            delete body.inicioContrato;
        if (body.fimContrato == "")
            delete body.fimContrato;
        if (body.dataNascimento == "")
            delete body.dataNascimento;



        if (inEditMode) {
            const formData = new FormData();

            const bodyChanged = { ...body };
            delete bodyChanged.formId;

            formData.append("data", JSON.stringify(bodyChanged));
            if (auxillaryData.docFile)
                formData.append("file", auxillaryData.docFile);

            const response = await FormService.saveForm(data.formId, formData);

        } else {
            const formData = new FormData();
            // TODO: REMOVE THIS ON BACKEND
            delete body.formId;

            formData.append("data", JSON.stringify(body));
            formData.append("file", auxillaryData.docFile);

            const response = await FormService.submitForm(formData);

            if (response.status >= 200 && response.status < 300 && AuthService.isInRole(["Bolsista"])) {
                history("/gerenciamento/formularios")
            }
        }

        setStatus("");
        setInProgress(false);
        init();

    }

    const generateTermo = async () => {
        setInProgress(true);
        setStatus("Gerando Termo...");

        let termoBlob = await FormService.getDownloadTermo(data.formId)
        downloadBlob(termoBlob, `${data.nomeCompleto}_termo.docx`);

        setInProgress(false);

    }

    const handleOnReject = async () => {


        const rejectResult = await ModalSystem.show<string>({
            id: "teste",
            component: TextareaDialog,
            props: {
                saveButtonText: "Rejeitar",
                label: "Descrição da recusa",
                saveButtonColor: "bg-red-500"
            },

            title: "Recusar Bolsa?",
            parameters: {

                size: "small",
                canClose: true,
                fill: {
                    height: true,
                    width: true
                }
            }
        });

        if (rejectResult) {
            setInProgress(true);
            setStatus("Rejeitando formulário...");

            let result = await FormService.updateStatus({
                id: data.formId,
                status: 2,
                statusUpdateDescription: rejectResult
            });

            setStatus("");
            setInProgress(false);
            history("/gerenciamento/formularios")
        }

    }

    const onCancel = () => {
        history("/gerenciamento/formularios")
    }

    const handleDownloadDocuments = async () => {

        setStatus(`Efetuando o download dos documentos `);
        let docName = `${data.nomeCompleto.trim()}_documento.pdf`
        await FormService.downloadDocuments(data.formId, docName);
    }

    const handleViewDocuments = async () => {
        ModalSystem.show({
            component: CorePdfViwer,
            id: "pdf-viewer",
            title: `Visualizar Documentos - ${data.nomeCompleto}`,
            props: {
                url: FormService.getPDFUrl(data.formId)
            },
            parameters: {
                size: "large"
            }
        });
    }

    const isProjectSelectReadOnly = (): boolean => {
        return (AuthService.isInRole(["Bolsista"])) && inEditMode ||
            AuthService.isInRole(["Coordenador", "Assistente"]);
    }



    return (
        <div className="flex flex-column flex-1 w-full  bg-gray-100">

            {/* menu */}
            <div className="grid grid-flow-col justify-end gap-2 px-4 pt-4">

                <CoreButton text="SALVAR" onClick={OnSave} schema="success" disabled={isInProgress || hasFormError || serverValidating} />

                {AuthService.isInRole(["FAEPI", "Faepi"]) &&
                    < CoreButton text="GERAR TERMO" onClick={generateTermo} schema="info" kind="outline" disabled={(isInProgress || hasFormError) || !data.processo || !data.termo || !FormService.IsAllowedToEmit(data.status)} />
                }


                {/* {!AuthService.isInRole(["Bolsista"]) &&
                    <CoreButton text="REJEITAR" onClick={handleOnReject} schema="danger" kind="outline" disabled={isInProgress || hasFormError || data.status == 2} />
                } */}

                <CoreButton text="CANCELAR" onClick={onCancel} color="bg-gray-500" colorHover="bg-gray-800" disabled={isInProgress} />

            </div>


            <div className="grid grid-flow-row px-6">
                <span className="text-gray-400 text-sm">Formulário de Bolsa</span>
                <span className="text-gray-500 text-lg font-semibold">{data.nomeCompleto}</span>
                <div className="grid grid-flow-col auto-cols-max items-center">
                    <FormStatus status={data.status as any} />
                    {data.status == 2 && <span className="text-red-500 text-xs p-2">{data.statusUpdateDescription}</span>}
                </div>
            </div>


            {/* Body */}
            <div className="rounded p-6 flex flex-1 overflow-hidden">


                {isInProgress
                    ?
                    <Loader enabled status={status} />
                    :
                    <div className="flex flex-1 bg-white p-6 shadow-md overflow-y-scroll">
                        <CoreForm onErrors={onFormError}>

                            <CoreTabs>

                                <CoreTab title="Dados Pessoais" hasError={tabErrors.dadodsPessoais}>

                                    <div className="grid grid-cols-2 gap-6 overflow-auto">

                                        <div className="grid grid-cols-1 place-content-start">

                                            <CoreInput
                                                name="nomeCompleto"
                                                label="Nome Completo"
                                                group="Dados Pessoais"
                                                value={data.nomeCompleto}
                                                type="text"
                                                onChange={onValueChange}
                                                readOnly={!AuthService.isInRole(["FAEPI", "Faepi"])} />

                                            <CoreInput
                                                name="nomeSocial"
                                                label="Nome Social"
                                                group="Dados Pessoais"
                                                value={data.nomeSocial}
                                                type="text"
                                                onChange={onValueChange}
                                            />

                                            <CoreInput
                                                name="email"
                                                group="Dados Pessoais"
                                                label="E-mail"
                                                value={data.email}
                                                type="text"
                                                readOnly />

                                            <CoreInput
                                                name="cpf"
                                                group="Dados Pessoais"
                                                label="CPF"
                                                value={data.cpf}
                                                type="text"
                                                readOnly />

                                            <Coreselect
                                                name="docenteDiscente"
                                                group="Dados Pessoais"
                                                label="Docente / Discente"
                                                items={docenteDiscenteList}
                                                value={data.docenteDiscente}
                                                onChange={onValueChange}
                                                dictionary={{ name: "name", value: "id" }} />

                                            <div className="grid grid-cols-2 gap-2" >
                                                {data.docenteDiscente == "Docente" &&
                                                    <Coreselect
                                                        name="isPublicServer"
                                                        label="Servidor Público?"
                                                        group="Dados Pessoais"
                                                        items={[
                                                            { name: "Sim", value: "true" },
                                                            { name: "Não", value: "false" }
                                                        ]}
                                                        value={auxillaryData.isPublicServer}
                                                        onChange={onAuxiliaryChange}
                                                        dictionary={{ name: "name", value: "value" }} />}

                                                {/* Docente e Servidor Publico */}
                                                {
                                                    data.docenteDiscente == "Docente" &&
                                                    auxillaryData.isPublicServer == "true" &&
                                                    <CoreInput
                                                        name="siape"
                                                        label="Siape"
                                                        group="Dados Pessoais"
                                                        value={data.siape}
                                                        type="text"
                                                        onChange={onValueChange}
                                                        validations={[RequiredValidation]} />
                                                }
                                            </div>

                                            {/* Discente */}
                                            {data.docenteDiscente == "Discente" &&
                                                <CoreInput
                                                    label="Matrícula"
                                                    group="Dados Pessoais"
                                                    name="matricula"
                                                    value={data.matricula}
                                                    type="text"
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]} />
                                            }



                                        </div>

                                        <div className="grid grid-cols-1 place-content-start">
                                            <div className="grid grid-cols-3 gap-2">
                                                <CoreInput
                                                    name="identidade"
                                                    group="Dados Pessoais"
                                                    label="RG"
                                                    value={data.identidade}
                                                    type="text"
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}


                                                />
                                                <CoreInput
                                                    name="pis"
                                                    group="Dados Pessoais"
                                                    label="PIS"
                                                    value={data.pis}
                                                    type="text"
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}


                                                />

                                                <Coreselect
                                                    name="estadoCivil"
                                                    group="Dados Pessoais"
                                                    label="Estado Civil"
                                                    items={estadosCivis}
                                                    value={data.estadoCivil}
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}
                                                    dictionary={{ name: "name", value: "value" }} />
                                            </div>

                                            <div className="grid grid-cols-2 gap-2">
                                                <CoreInput
                                                    type="date"
                                                    group="Dados Pessoais"
                                                    label="Data de Nascimento"
                                                    name="dataNascimento"
                                                    beforeValue={(v: string) => v.split("T")[0]}
                                                    value={data.dataNascimento}
                                                    afterValue={(v: string) => `${v}T00:00:00`}
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}
                                                />

                                                <CoreInput
                                                    type="text"
                                                    group="Dados Pessoais"
                                                    label="Nacionalidade"
                                                    name="nacionalidade"
                                                    value={data.nacionalidade}
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}

                                                />

                                            </div>
                                            <div className="grid grid-cols-1 place-content-start">
                                                <CoreInput
                                                    label="Nome da Mãe"
                                                    group="Dados Pessoais"
                                                    name="mae"
                                                    value={data.mae}
                                                    type="text"
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]} />
                                                <CoreInput
                                                    label="Nome do Pai"
                                                    group="Dados Pessoais"
                                                    name="pai"
                                                    value={data.pai}
                                                    type="text"
                                                    onChange={onValueChange} />
                                                {

                                                    AuthService.isInRole(["Bolsista", "FAEPI", "Faepi"]) &&
                                                    <CoreInput
                                                        label="Documentos"
                                                        group="Dados Pessoais"
                                                        name="docFile"
                                                        type="file"
                                                        placeholder="*arquivo único com RG, CPF, COMPROVANTE DE RESIDÊNCIA, DADOS BANCÁRIOS E DECLARAÇÃO DE VÍNCULO"
                                                        fileAccept=".pdf"
                                                        onChange={onAuxiliaryChange}
                                                        validations={[!inEditMode && RequiredValidation]} />

                                                }
                                                {
                                                    inEditMode && <div className="grid grid-flow-col gap-4 auto-cols-max">

                                                        <CoreButton
                                                            text="Visualizar Documentos" kind="outline" schema="info"
                                                            disabled={isInProgress} onClick={handleViewDocuments} />

                                                        <CoreButton
                                                            text="Download Documentos" kind="outline" schema="warning"
                                                            disabled={isInProgress} onClick={handleDownloadDocuments} />


                                                    </div>
                                                }

                                            </div>

                                        </div>

                                    </div>

                                </CoreTab>

                                <CoreTab title="Contato" hasError={tabErrors.contato}>
                                    <div className="grid grid-cols-2 gap-6 overflow-auto">

                                        <div className="grid grid-cols-1 place-content-start">

                                            <CoreInput
                                                type="text"
                                                group="Contato"
                                                label="Endereço"
                                                name="endereco"
                                                value={data.endereco}
                                                onChange={onValueChange}
                                                validations={[RequiredValidation]}
                                            />

                                            <CoreInput
                                                type="text"
                                                group="Contato"
                                                label="Complemento"
                                                name="complemento"
                                                value={data.complemento}
                                                onChange={onValueChange}
                                            />

                                            <div className="grid grid-cols-3 place-content-start gap-4">
                                                <CoreInput
                                                    type="text"
                                                    group="Contato"
                                                    label="Bairro"
                                                    name="bairro"
                                                    value={data.bairro}
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}
                                                />

                                                <CoreInput
                                                    type="text"
                                                    group="Contato"
                                                    label="Cidade"
                                                    name="cidade"
                                                    value={data.cidade}
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}
                                                />


                                                <CoreInput
                                                    type="text"
                                                    group="Contato"
                                                    label="Estado"
                                                    name="estado"
                                                    value={data.estado}
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}
                                                />

                                            </div>


                                        </div>

                                        <div className="grid grid-cols-3 place-content-start gap-4">
                                            <CoreInput
                                                type="text"
                                                group="Contato"
                                                label="Cep"
                                                name="cep"
                                                value={data.cep}
                                                onChange={onValueChange}
                                                validations={[RequiredValidation]}
                                                mask="11111-111"
                                            />

                                            <CoreInput
                                                type="text"
                                                group="Contato"
                                                label="Telefone Principal"
                                                name="fone"
                                                value={data.fone}
                                                onChange={onValueChange}
                                                validations={[RequiredValidation]}
                                                mask="(11) 11111-1111"


                                            />

                                            <CoreInput
                                                type="text"
                                                group="Contato"
                                                label="Telefone Opcional"
                                                name="fone2"
                                                value={data.fone2}
                                                onChange={onValueChange}
                                                mask="(11) 11111-1111"
                                            />


                                        </div>
                                    </div>
                                </CoreTab>

                                <CoreTab title="Dados Bancários" hasError={tabErrors.dadosBancarios}>

                                    <div className="grid grid-cols-1 place-content-start">

                                        <div className="grid grid-cols-4 place-content-start gap-4">
                                            <CoreInput
                                                type="text"
                                                group="Dados Bancários"
                                                label="Banco"
                                                name="banco"
                                                value={data.banco}
                                                showSearch
                                                searchItems={listaBancos.map(l => l.name)}
                                                onChange={onValueChange}
                                                validations={[RequiredValidation]}
                                            />

                                            <Coreselect
                                                label="Tipo de Conta"
                                                group="Dados Bancários"
                                                name="tipoConta"
                                                value={data.tipoConta}
                                                items={[{ name: "Corrente" }, { name: "Poupança" }]}
                                                dictionary={{ name: "name", value: "name" }}
                                                onChange={onValueChange}
                                            />

                                            <CoreInput
                                                type="text"
                                                group="Dados Bancários"
                                                label="Agência com dígito"
                                                name="agencia"
                                                value={data.agencia}
                                                onChange={onValueChange}
                                                validations={[RequiredValidation]}
                                                mask="1111-1"
                                            />

                                            <CoreInput
                                                type="text"
                                                group="Dados Bancários"
                                                label="Conta com dígito"
                                                name="conta"
                                                value={data.conta}
                                                placeholder="Exemplo 0123-1"
                                                onChange={onValueChange}
                                                validations={[RequiredValidation]}

                                            />


                                        </div>

                                        <div className="grid grid-cols-4 gap-4">
                                            <Coreselect
                                                label="Tipo de Chave Pix"
                                                group="Dados Bancários"
                                                name="tipoChavePix"
                                                value={data.tipoChavePix}
                                                items={[
                                                    { name: "CPF" },
                                                    { name: "E-mail" },
                                                    { name: "Número de telefone Celular" },
                                                    { name: "Chave aleatória" }]}
                                                dictionary={{ name: "name", value: "name" }}
                                                onChange={onValueChange}
                                            />

                                            {data.tipoChavePix == "CPF" &&
                                                <CoreInput
                                                    type="text"
                                                    group="Dados Bancários"
                                                    label="CPF"
                                                    name="chavePix"
                                                    value={data.chavePix}
                                                    onChange={onValueChange}
                                                    validations={[RequiredValidation]}
                                                    mask="111.111.111-11"
                                                />
                                            }


                                            {data.tipoChavePix == "E-mail" &&
                                                <CoreInput
                                                    type="text"
                                                    group="Dados Bancários"
                                                    label="E-mail"
                                                    name="chavePix"
                                                    value={data.chavePix}
                                                    onChange={onValueChange}
                                                    validations={[
                                                        RequiredValidation,
                                                        RegexValidation(Expressions.EMAIL, "Este não parece ser um e-mail válido")]}
                                                />
                                            }

                                            {data.tipoChavePix == "Número de telefone Celular" &&
                                                <CoreInput
                                                    type="text"
                                                    group="Dados Bancários"
                                                    label="Celular"
                                                    name="chavePix"
                                                    value={data.chavePix}
                                                    onChange={onValueChange}
                                                    mask="(11) 1111-1111"
                                                    validations={[
                                                        RequiredValidation,
                                                    ]}
                                                />
                                            }

                                            {data.tipoChavePix == "Chave aleatória" &&
                                                <CoreInput
                                                    type="text"
                                                    group="Dados Bancários"
                                                    label="Chave aleatória"
                                                    name="chavePix"
                                                    value={data.chavePix}
                                                    onChange={onValueChange}
                                                    validations={[
                                                        RequiredValidation,
                                                    ]}
                                                />
                                            }
                                        </div>



                                    </div>
                                </CoreTab>

                                <CoreTab title="Projeto">
                                    <div className="grid grid-cols-2 gap-6 overflow-auto">
                                        <div className="grid grid-cols-1 place-content-start">
                                            <Coreselect
                                                label="Projeto"
                                                group="Projeto"
                                                name="projetoId"
                                                value={data.projetoId}
                                                items={auxillaryData.projetos}
                                                dictionary={{ name: "nomeProjeto", value: "projetoId" }}
                                                onChange={onValueChange}
                                                readonly={
                                                    isProjectSelectReadOnly()
                                                }

                                            />
                                        </div>
                                        <div className="grid grid-cols-2 gap-6 place-content-start">
                                            <CoreInput
                                                type="text"
                                                label="Coordenador do Projeto"
                                                readOnly
                                                name="coordenadorProjeto"
                                                value={auxillaryData.coordenadorProjetoNome}

                                            />
                                            <CoreInput
                                                type="text"
                                                readOnly
                                                label="Coordenador Técnico"
                                                name="coordenadorTecnico"
                                                value={auxillaryData.coordenadorChefeNome}

                                            />

                                            <CoreInput
                                                type="text"
                                                readOnly
                                                label="Coordenador de Unidade"
                                                name="coordenadorUnidade"
                                                value={auxillaryData.coordenadorUnidadeNome}

                                            />

                                            <CoreInput
                                                type="text"
                                                readOnly
                                                label="Instituição Executadora"
                                                name="instituicaoExecutora"
                                                value={auxillaryData.instituicaoExecutora}

                                            />

                                            <CoreInput
                                                type="text"
                                                readOnly
                                                label="Modalidade"
                                                name="modalidade"
                                                value={auxillaryData.modalidade}

                                            />

                                            <CoreInput
                                                type="date"
                                                readOnly
                                                label="Início do Projeto"
                                                name="inicioProjeto"
                                                beforeValue={(v: string) => {
                                                    if (!v) return "";
                                                    return v.split("T")[0];
                                                }}
                                                value={auxillaryData.inicioProjeto}

                                            />
                                            <CoreInput
                                                type="date"
                                                readOnly
                                                label="Fim do Projeto"
                                                name="fimProjeto"
                                                beforeValue={(v: string) => {
                                                    if (!v) return "";
                                                    return v.split("T")[0];
                                                }}
                                                value={auxillaryData.fimProjeto}

                                            />
                                        </div>

                                    </div>
                                </CoreTab>





                                <CoreTab title="Contrato" hasError={tabErrors.contrato} hasWarning={auxillaryData.serverValidations.length > 0} >
                                    <div className="grid grid-cols-2 gap-6 overflow-auto">
                                        <div className="grid grid-cols-1 place-content-start">
                                            <CoreInput
                                                name="funcao"
                                                group="Contrato"
                                                label="Função"
                                                value={data.funcao}
                                                type="text"
                                                onChange={onValueChange}
                                                readOnly={AuthService.isInRole(["Bolsista"])}
                                                validations={[!AuthService.isInRole(["Bolsista"]) && RequiredValidation, MaxLength(150)]} />

                                            <div className="grid grid-cols-3 gap-6 place-content-start">
                                                <CoreInput
                                                    type="date"
                                                    group="Contrato"
                                                    label="Inicio do Contrato"
                                                    name="inicioContrato"
                                                    beforeValue={(v: string) => {
                                                        return v.split("T")[0];
                                                    }}
                                                    value={data.inicioContrato}
                                                    afterValue={(v: string) => `${v}T00:00:00`}
                                                    onChange={onValueChange}
                                                    readOnly={AuthService.isInRole(["Bolsista"])}

                                                />
                                                <CoreInput
                                                    type="date"
                                                    group="Contrato"
                                                    label="Fim do Contrato"
                                                    name="fimContrato"
                                                    beforeValue={(v: string) => {
                                                        return v.split("T")[0];
                                                    }}
                                                    value={data.fimContrato}
                                                    afterValue={(v: string) => `${v}T00:00:00`}
                                                    onChange={onValueChange}
                                                    readOnly={AuthService.isInRole(["Bolsista"])}

                                                />
                                                <CoreInput
                                                    type="number"
                                                    group="Contrato"
                                                    label="Carga Horária Total"
                                                    name="cargaHoraria"
                                                    value={data.cargaHoraria}
                                                    onChange={onValueChange}
                                                    readOnly={AuthService.isInRole(["Bolsista"])}

                                                />
                                            </div>
                                            <div className="grid grid-cols-1 gap-6 place-content-start">

                                                <Loader enabled={serverValidating} status="Validando as datas do contrato..." />
                                            </div>

                                            {
                                                auxillaryData.serverValidations.length > 0 &&
                                                <div className="grid grid-flow-col auto-cols-max py-2  align-middle">
                                                    <AlertIcon className="stroke-amber-600" size={32} />
                                                    <div className="grid grid-flow-row">
                                                        {auxillaryData.serverValidations.map((validation, index) => {
                                                            return (
                                                                <span key={index} className="text-amber-600">{validation}</span>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            }

                                        </div>


                                        <div className="grid grid-cols-3 gap-6 place-content-start">
                                            <CoreInput
                                                type="number"
                                                group="Contrato"
                                                label="Quantidade de Parcelas"
                                                name="quantidadeParcelas"
                                                value={data.quantidadeParcelas}
                                                onChange={onValueChange}
                                                readOnly={AuthService.isInRole(["Bolsista"])}

                                            />

                                            <CoreInput
                                                type="currency"
                                                group="Contrato"
                                                label="Valor Parcela"
                                                name="valorParcela"
                                                value={data.valorParcela}
                                                onChange={onValueChange}
                                                readOnly={AuthService.isInRole(["Bolsista"])}

                                            />

                                            <CoreInput
                                                type="text"
                                                group="Contrato"
                                                label="ValorTotal"
                                                name="valorBruto"
                                                beforeValue={(v) => `R$ ${v.toLocaleString().replace(",", ".")}`}
                                                value={data.valorBruto}
                                                readOnly

                                            />
                                        </div>
                                    </div>

                                </CoreTab>
                                {
                                    AuthService.isInRole(["FAEPI"]) &&
                                    <CoreTab title="Termo" hasError={tabErrors.termo}>
                                        <div className="grid grid-cols-3 gap-6 place-content-start">
                                            <CoreInput
                                                type="text"
                                                group="Termo"
                                                label="Termo"
                                                name="termo"
                                                value={data.termo}
                                                onChange={onValueChange}
                                            />
                                            <CoreInput
                                                type="text"
                                                group="Termo"
                                                label="Processo"
                                                name="processo"
                                                value={data.processo}
                                                onChange={onValueChange}
                                            />

                                        </div>

                                    </CoreTab>
                                }

                                {
                                    !AuthService.isInRole(["Bolsista"]) &&
                                    <CoreTab title="Status" hasError={tabErrors.termo}>
                                        <div className="grid grid-cols-3 gap-6 place-content-start">
                                            <Coreselect
                                                name="status"
                                                group="status"
                                                label="Status do processo"
                                                items={FormStatusList}
                                                value={data.status}
                                                valueFormat="number"
                                                onChange={onValueChange}
                                                dictionary={{ name: "name", value: "value" }} />

                                            {/* only Rejected has messages */}
                                            {data.status == 2 &&
                                                <CoreInput
                                                    type="textarea"
                                                    rows={4}
                                                    group="status"
                                                    label="Descrição da rejeição"
                                                    name="statusUpdateDescription"
                                                    value={data.statusUpdateDescription}
                                                    onChange={onValueChange}
                                                />

                                            }



                                        </div>

                                    </CoreTab>
                                }
                            </CoreTabs>


                        </CoreForm>
                    </div>
                }



            </div>

        </div>

    )


};

